module.exports = __webpack_public_path__ + "static/media/art9.60343ed5.png";